import axios from 'axios';

// 🔐 Get JWT token from localStorage
// const jwtToken:string|null= localStorage.getItem('authToken');
const jwtToken: string | null = localStorage.getItem('jwtToken'); // Adjust the key name as per your storage

const headers = {
  'Content-Type': 'application/json',
  'Authorization': jwtToken ? `Bearer ${jwtToken}` : '' // Correct way to conditionally set the header
};

// Create an axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  // ...other config
});

// Add a response interceptor
api.interceptors.response.use(
  response => response,
  error => {
    // Check for JWT expired error
    if (
      error.response &&
      error.response.status === 500 &&
      error.response.data &&
      error.response.data.message &&
      error.response.data.message.includes('JWT expired')
    ) {
      // Remove token from storage if needed
      localStorage.removeItem('jwtToken');
      // Redirect to login page
      window.location.href = '/';
      // Or, as a fallback, reload the page
      // window.location.reload();
      return Promise.reject(error);
    }

    else if (
      error.response &&
      error.response.status === 400 &&
      error.response.data &&
      error.response.data.includes('Hospital with the given codes already exists')
    ) {
      console.log(error.response.data);
      return Promise.reject(error.response.data);
    }
    else
      return Promise.reject(error);

  }
);

export default api;

export const post = async (url: string, payLoad: any) => {
  try {
    const response = await api.post(url, payLoad, { headers });
    return response.data;
  } catch (err: any) {
    // Optionally log the error for debugging
    console.error('API POST error:', err);

    // Custom user-friendly error messages
    if (err.response && err.response.status === 404) {
      throw new Error('User not found. Please contact the application administrator.');
    }
    if (err.response && err.response.status === 403) {
      throw new Error('User does not have the required "admin" role.');
    }
    if (err.response && err.response.status === 400) {
      throw new Error('Invalid request. Please check your input and try again.');
    }
    if (err.response && err.response.status === 500) {
      throw new Error('Server error. Please try again later.');
    }
    // Fallback for other errors
    throw new Error('Something went wrong. Please try again.');
  }
}


export const get = async (url: string) => {
  try {
    const response = await api.get(url, { headers });
    return response.data;
  } catch (err) {
    if (err instanceof Error) {
      throw new Error(`Failed to get data: ${err.message}`);
    } else {
      alert('An unknown error occurred during GET request.');
      throw new Error('An unknown error occurred during GET request');
    }
  }
}


export const put = async (url: string, payLoad: any) => {
  try {
    const response = await api.put(url, payLoad, { headers });
    return response.data;
  } catch (err) {
    if (err instanceof Error) {
      alert('Failed to update data: ' + err.message);
      throw new Error(`Failed to update data: ${err.message}`);
    } else {
      alert('An unknown error occurred during PUT request.');
      throw new Error('An unknown error occurred during PUT request');
    }
  }
}

export const deleteApi = async (url: string) => {
  try {
    const response = await api.delete(url, { headers });
    return response.data;
  } catch (err) {
    if (err instanceof Error) {
      alert('Failed to delete data: ' + err.message);
      throw new Error(`Failed to delete data: ${err.message}`);
    } else {
      alert('An unknown error occurred during DELETE request.');
      throw new Error('An unknown error occurred during DELETE request');
    }
  }
};